export function getAverageRating(reviews) {
  let ratingCount = 0;
  let ratingTotal = 0;
  for (const review of reviews.edges) {
    ratingTotal = review.node.rating + ratingTotal;
    ratingCount++;
  }
  let average = ratingTotal / ratingCount;

  return average;
}